//import { Link } from "gatsby"
//import Image from "../components/image"
import PropTypes from "prop-types"
import React, { useState } from "react"

import HeaderLogo from "../components/header-logo/header-logo"
import ButtonMobileMenu from "../components/buttons/button-mobile-menu/button-mobile-menu"
import Navigation from "../components/navigation/navigation"

const Header = ({ siteTitle }) => {
  let [mobileNavIsOpen, setMobileNavIsOpen] = useState(false)

  let toggleMobileNav = () => {
    console.log("toggle")
    mobileNavIsOpen ? setMobileNavIsOpen(false) : setMobileNavIsOpen(true)
  }

  return (
    <header className="header" role="banner">
      <div className="container">
        <HeaderLogo />
        <ButtonMobileMenu
          onClick={toggleMobileNav}
          mobileNavIsOpen={mobileNavIsOpen}
        />
        <Navigation
          mobileNavIsOpen={mobileNavIsOpen}
          clickHandler={toggleMobileNav}
        />
      </div>
    </header>
  )
}

Header.propTypes = {
  siteTitle: PropTypes.string,
}

Header.defaultProps = {
  siteTitle: ``,
}

export default Header
